import React, { Component } from 'react';
import moment from 'moment';

export default class ChatViewCentral extends Component {

    constructor(props) {
        super(props);

        this.state = {

        }
    }

    render() {

        return (
            <div className="profile-central-outer">
                <div className="error-message-outer">
                    <div className="error-image-container">
                        <div className="error-image material-icons">chat</div>
                    </div>
                    <div className="error-message-container">
                        <div className="error-message">Coming Soon</div>
                    </div>
                </div>
            </div>
        );
    }
}